// Content payload for the six BLEZZINGS sub-brand pages.
// Optional fields (audience, bullets, capital, formats) are rendered
// conditionally by /pages/BusinessPage.jsx.

export const BUSINESS_PAGES = {
  "growth-partners": {
    name: "BLEZZINGS Growth Partners",
    descriptor: "Sales & Marketing Transformation",
    metaDescription:
      "A specialist Sales & Marketing transformation firm helping ambitious businesses accelerate profitable growth through end-to-end strategy and execution.",
    hero: "Accelerate profitable growth through better Sales & Marketing.",
    heroImage:
      "/photos/growth-partners.jpg",
    heroImageAlt:
      "Indian sales team reviewing growth charts on a large screen in a bright modern office",
    bandImage:
      "/photos/expertise-sales.jpg",
    bandImageAlt:
      "Indian businessmen in suits shaking hands on a deal in a bright modern office",
    intro: [
      "BLEZZINGS Growth Partners is a specialist Sales & Marketing transformation firm that helps ambitious businesses accelerate profitable growth through end-to-end strategy and execution.",
      "We work with businesses that want to grow faster, strengthen their market position, improve commercial performance and make growth more profitable.",
      "Our approach goes beyond recommendations. We work with leadership and commercial teams to understand the problem, develop practical solutions, execute them in the market and build capabilities that sustain results.",
    ],
    offerings: {
      title: "What We Do",
      heading: "Six ways we help businesses grow.",
      items: [
        { name: "Sales Transformation", body: "Improve sales productivity, effectiveness and performance across people, processes, territories, channels, incentives and sales management." },
        { name: "Marketing Transformation", body: "Strengthen marketing strategy, customer acquisition, demand generation, brand effectiveness and marketing ROI." },
        { name: "Go-to-Market Transformation", body: "Build stronger go-to-market strategies for new products, markets, segments, channels and geographies." },
        { name: "Channel & Distribution", body: "Improve distributor and dealer productivity, route-to-market, channel economics, market coverage and partner performance." },
        { name: "Revenue & Profit Growth", body: "Identify and execute opportunities to grow revenue while improving margins, productivity, customer economics and commercial efficiency." },
        { name: "Commercial Excellence", body: "Build stronger commercial operating models, KPIs, governance, accountability and performance management systems." },
      ],
    },
    process: {
      title: "From Strategy to Execution",
      lead: "Strategy creates direction. Execution creates results. Our engagements can span the full transformation journey.",
      steps: ["Diagnose", "Strategise", "Design", "Execute", "Measure", "Institutionalise"],
    },
    audience: {
      title: "Who We Work With",
      lead: "We work with ambitious businesses across industries and stages of growth.",
      groups: [
        { name: "Mid & Early-stage Startups", body: "Ambitious startups building scalable Sales & Marketing engines from day one." },
        { name: "Promoter-led Businesses", body: "Founder- and family-owned businesses looking to professionalise and scale." },
        { name: "Professionally Managed Companies", body: "Mid-market and large organisations sharpening commercial performance." },
        { name: "High-growth Organisations", body: "Fast-growing businesses that need to scale Sales & Marketing without losing focus." },
        { name: "Larger Enterprises", body: "Established enterprises pursuing new markets, segments or growth models." },
      ],
    },
    philosophy: {
      title: "Our Philosophy",
      body: "Growth should not simply increase the topline. The objective is profitable, sustainable growth — improving not only how much a business sells, but how effectively it acquires customers, deploys resources, manages channels and converts growth into economic value.",
    },
    closing: {
      title: "Have a Sales or Marketing challenge that is holding back growth?",
      subtitle: "Let's solve it — and execute the solution.",
      cta: "Talk to Growth Partners",
    },
    lockup: "Strategy. Execution. Growth.",
  },

  academy: {
    name: "BLEZZINGS Academy",
    descriptor: "Leadership. Capability. Performance.",
    metaDescription:
      "Practical learning, executive coaching and leadership development designed to help people and organisations perform better.",
    hero: "Build better leaders. Build better businesses.",
    heroImage:
      "/photos/academy.jpg",
    heroImageAlt:
      "Indian executive coach leading a premium leadership masterclass in a boardroom",
    bandImage:
      "/photos/academy-band.jpg",
    bandImageAlt:
      "Senior Indian executive coach mentoring a young business leader one-on-one in a bright office",
    intro: [
      "BLEZZINGS Academy is the learning and leadership platform of BLEZZINGS, focused on developing business leaders, professionals and teams for the realities of a rapidly changing business environment.",
      "We combine practical business knowledge, real-world experience and applied learning to help people perform better, lead better and create greater business impact.",
      "Our philosophy is simple: learning should change behaviour. Behaviour should improve performance.",
    ],
    offerings: {
      title: "What We Offer",
      heading: "Programmes designed for real business impact.",
      items: [
        { name: "Executive Coaching", body: "One-to-one coaching for founders, business owners, senior executives and emerging leaders." },
        { name: "Leadership Development", body: "Programs designed to strengthen strategic thinking, leadership effectiveness, decision-making and organisational influence." },
        { name: "Corporate Training", body: "Practical, business-focused interventions across Sales, Marketing, Leadership, Management and other critical capabilities." },
        { name: "Workshops & Masterclasses", body: "Highly focused sessions designed around specific business challenges and capability gaps." },
        { name: "Online Courses", body: "Flexible learning experiences that enable professionals and business owners to develop relevant skills at their own pace." },
        { name: "Executive Education", body: "Business-oriented programmes for professionals seeking deeper expertise in strategy, growth, Sales, Marketing and management." },
      ],
    },
    bullets: {
      title: "Learning That Connects to Business",
      lead: "Our programmes are designed to help participants:",
      items: [
        "Think more strategically",
        "Make better decisions",
        "Lead more effectively",
        "Solve business problems",
        "Execute with greater discipline",
        "Improve measurable performance",
      ],
    },
    process: {
      title: "Our Approach",
      lead: "We bring together concepts, frameworks, cases, exercises, discussions and practical assignments to make learning relevant to the real world.",
      steps: ["Learn", "Apply", "Practice", "Improve", "Perform"],
    },
    audience: {
      title: "Who We Serve",
      lead: null,
      groups: [
        { name: "Business Owners", body: "Strengthen leadership and build scalable businesses." },
        { name: "CXOs & Senior Executives", body: "Develop strategic and leadership capabilities." },
        { name: "Managers & Professionals", body: "Build the skills required to move to the next level." },
        { name: "Sales & Marketing Teams", body: "Improve commercial capabilities and execution." },
        { name: "Organisations", body: "Build stronger leadership pipelines and high-performance teams." },
      ],
    },
    philosophy: {
      title: "Our Philosophy",
      body: "Learning should change behaviour. Behaviour should improve performance. Everything we design at Academy is built around that belief.",
    },
    closing: {
      title: "Better businesses begin with better leaders and stronger capabilities.",
      subtitle: "Explore BLEZZINGS Academy.",
      cta: "View Programmes",
    },
    lockup: "Learn. Lead. Perform.",
  },

  publications: {
    name: "BLEZZINGS Publications",
    descriptor: "Books. Research. Ideas.",
    metaDescription:
      "Books, research and original thinking that help people understand business, markets, leadership and the world around them.",
    hero: "Ideas worth reading. Thinking worth sharing.",
    heroImage:
      "/photos/publications.jpg",
    heroImageAlt: "Indian professional selecting a business book in a sunlit modern bookstore",
    bandImage:
      "/photos/publications-band.jpg",
    bandImageAlt:
      "Indian author writing and editing a book manuscript at a wooden desk in a sunlit study",
    intro: [
      "BLEZZINGS Publications is the knowledge and intellectual-property arm of BLEZZINGS, created to develop, publish and distribute ideas that contribute to better business thinking and a deeper understanding of the world around us.",
      "We believe ideas become more valuable when they are documented, challenged, refined and shared.",
      "Through books, reports, research, essays, frameworks and other forms of intellectual content, BLEZZINGS Publications seeks to turn experience and insight into lasting knowledge.",
    ],
    offerings: {
      title: "What We Publish",
      heading: "Turning ideas into intellectual property.",
      items: [
        { name: "Books", body: "Original books covering business, management, leadership, Sales, Marketing, growth and other subjects of relevance to professionals and society." },
        { name: "Business Reports", body: "Research-led reports that explore markets, industries, trends, businesses and emerging opportunities." },
        { name: "Research & Studies", body: "Structured research designed to generate useful insights for leaders, professionals and organisations." },
        { name: "Thought Leadership", body: "Original perspectives, frameworks and ideas that challenge conventional thinking." },
        { name: "Business Cases", body: "Real-world stories and case studies that turn experience into actionable learning." },
        { name: "Special Editions & Knowledge Projects", body: "Curated publications around specific industries, themes and business questions." },
      ],
    },
    process: {
      title: "From Experience to Intellectual Property",
      lead: "Knowledge that can travel beyond the original conversation.",
      steps: ["Problem", "Framework", "Research", "Report", "Book"],
    },
    philosophy: {
      title: "Our Editorial Philosophy",
      body: "Original thinking that adds something meaningful. Practical relevance that helps people understand or act. Intellectual rigour, responsibly developed. Clarity — because complex ideas deserve clear communication.",
    },
    closing: {
      title: "Read. Think. Question. Apply.",
      subtitle: "Ideas worth reading. Thinking worth sharing.",
      cta: "Explore Publications",
    },
    lockup: "Read. Think. Question.",
  },

  ventures: {
    name: "BLEZZINGS Ventures",
    descriptor: "Investing. Building. Partnering.",
    metaDescription:
      "Backing promising founders, investing in businesses with potential and building ventures that create lasting value.",
    hero: "Backing ambitious founders and building businesses with potential.",
    heroImage:
      "/photos/ventures.jpg",
    heroImageAlt:
      "Indian startup founders pitching to investors in a bright modern office",
    bandImage:
      "/photos/expertise-marketing.jpg",
    bandImageAlt:
      "Indian team reviewing a colorful growth analytics dashboard on a large screen",
    intro: [
      "BLEZZINGS Ventures is the investment and venture-building arm of BLEZZINGS, focused on identifying promising businesses, supporting ambitious founders and participating in the creation of enduring value.",
      "We believe capital is most powerful when combined with experience, strategic thinking, networks and active partnership.",
      "Our approach goes beyond writing a cheque.",
    ],
    offerings: {
      title: "What We Explore",
      heading: "Where we invest and how we partner.",
      items: [
        { name: "Angel Investments", body: "Early-stage opportunities where entrepreneurial ambition is matched by a compelling business proposition." },
        { name: "Venture Investments", body: "Investments in businesses with the potential to build scalable and sustainable value." },
        { name: "Strategic Investments", body: "Opportunities where BLEZZINGS can contribute more than capital through business knowledge, commercial expertise and networks." },
        { name: "Venture Building", body: "Working with founders and teams to develop new businesses, validate opportunities and build scalable ventures." },
        { name: "Incubation & Acceleration", body: "Supporting promising ideas and ventures as they move from concept to market and from early traction to scale." },
      ],
    },
    process: {
      title: "What We Look For",
      lead: "Opportunities where we see the potential for enduring value.",
      steps: ["Strong Founders", "Growing Markets", "Differentiated Value", "Scalable Economics", "Long-term Potential"],
    },
    capital: {
      title: "More Than Capital",
      lead: "BLEZZINGS' broader ecosystem gives Ventures access to capabilities across:",
      items: ["Strategy", "Sales", "Marketing", "Growth", "Leadership", "Knowledge", "Networks"],
      footer: "Where appropriate, we can support founders beyond the investment itself.",
    },
    philosophy: {
      title: "Our Philosophy",
      body: "Invest with conviction. Build with patience. Create with purpose. The strongest ventures are built through a combination of ambition, disciplined execution, strong people and long-term thinking.",
    },
    closing: {
      title: "Are you building something ambitious?",
      subtitle: "We'd like to hear from you.",
      cta: "Connect with Ventures",
    },
    lockup: "Invest. Build. Grow.",
  },

  "blezz-talks": {
    name: "BLEZZ Talks",
    descriptor: "Conversations. Perspectives. Ideas.",
    metaDescription:
      "Conversations with leaders, entrepreneurs, experts and thinkers through interviews, podcasts, webinars and talks.",
    hero: "Conversations that challenge thinking.",
    heroImage:
      "/photos/blezz-talks.jpg",
    heroImageAlt:
      "Senior Indian executive recording an interview podcast with a host in a warm studio",
    bandImage:
      "/photos/talks-band.jpg",
    bandImageAlt:
      "Senior Indian executive in a fireside chat with an interviewer on a warmly lit stage with an audience",
    media: true,
    formats: ["Podcasts", "Interviews", "Webinars", "Fireside Chats", "Master Talks", "Founder Stories"],
    intro: [
      "BLEZZ Talks is BLEZZINGS' platform for conversations with business leaders, entrepreneurs, experts, creators and thinkers.",
      "Through interviews, podcasts, webinars, fireside conversations, talks and other formats, BLEZZ Talks brings together people with experience, ideas and perspectives worth hearing.",
      "We believe the most valuable insights often emerge not from presentations, but from honest conversations.",
    ],
    offerings: {
      title: "What You'll Find",
      heading: "Conversations across formats.",
      items: [
        { name: "Leader Conversations", body: "Conversations with CEOs, founders, CXOs and business leaders on leadership, growth, strategy and the challenges of building organisations." },
        { name: "Expert Perspectives", body: "Insights from specialists across Business, Sales, Marketing, Technology, Finance, Leadership and other relevant areas." },
        { name: "Founder Stories", body: "The journeys behind businesses — the decisions, failures, turning points and lessons that rarely appear in a company brochure." },
        { name: "Webinars & Master Talks", body: "Focused discussions that explore important business questions and practical themes." },
        { name: "Fireside Conversations", body: "More candid and personal conversations around leadership, entrepreneurship, ambition and learning." },
      ],
    },
    process: {
      title: "Our Editorial Approach",
      lead: "We aren't interested in conversations simply because someone has a title. We look for:",
      steps: ["Experience", "Insight", "Perspective", "Relevance"],
    },
    philosophy: {
      title: "What Every Conversation Should Deliver",
      body: "A new idea. A useful perspective. A better question.",
    },
    closing: {
      title: "Listen. Watch. Question. Think.",
      subtitle: "New conversations, coming soon.",
      cta: "Explore BLEZZ Talks",
    },
    lockup: "Listen. Learn. Think.",
  },

  foundation: {
    name: "BLEZZINGS Foundation",
    descriptor: "Social Impact. Opportunity. Dignity.",
    metaDescription:
      "Creating opportunities and supporting initiatives across education, livelihoods, entrepreneurship and community development.",
    hero: "Creating opportunity. Enabling potential. Making a difference.",
    heroImage:
      "/photos/foundation.jpg",
    heroImageAlt:
      "Suited Indian mentor guiding young aspiring entrepreneurs at an Entrepreneurship Development Program session",
    bandImage:
      "/photos/foundation-band.jpg",
    bandImageAlt:
      "Young Indian entrepreneurs presenting their business idea on a laptop to a senior mentor in a community hall",
    intro: [
      "BLEZZINGS Foundation is the social-impact and philanthropic arm of BLEZZINGS, focused on creating meaningful and sustainable impact in the communities we touch.",
      "We believe business success has a broader responsibility: to create opportunity, expand access, enable potential and contribute positively to society.",
      "The Foundation seeks to support initiatives where focused effort and responsible intervention can create lasting change.",
    ],
    offerings: {
      title: "Our Areas of Focus",
      heading: "Where we choose to create impact.",
      items: [
        { name: "Education", body: "Supporting access to meaningful learning, educational opportunities and capability development." },
        { name: "Livelihoods & Employability", body: "Creating pathways for people to develop skills, improve employability and build sustainable livelihoods." },
        { name: "Entrepreneurship", body: "Encouraging entrepreneurship and supporting individuals who seek to create economic opportunity for themselves and others." },
        { name: "Community Development", body: "Supporting initiatives that strengthen communities and improve quality of life." },
        { name: "Inclusion & Opportunity", body: "Helping create greater access to opportunities for people and communities that may otherwise be underserved." },
      ],
    },
    process: {
      title: "Our Approach",
      lead: "Impact should be purpose-led, practical, sustainable and responsible.",
      steps: ["Purpose-led", "Practical", "Sustainable", "Responsible"],
    },
    philosophy: {
      title: "From Success to Impact",
      body: "Growth should create more than financial value. It should create opportunity and positive impact. Through partnerships, initiatives, grants, programmes and community engagement, the Foundation contributes to a more capable, empowered and inclusive society.",
    },
    closing: {
      title: "Together, small actions can create lasting change.",
      subtitle: "Learn more about the Foundation.",
      cta: "Discover Foundation",
    },
    lockup: "Create Opportunity. Create Impact.",
  },
};
